import { Modal } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';

interface Props {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

/**
 * Confirmation dialog shown when a user attempts to leave a page (or
 * exit edit mode) with unsaved changes. Pairs with `useDirtyStateBlocker`
 * for route-nav guarding; can also be driven by local state for in-page
 * "cancel editing" flows.
 *
 * @category Overlays
 */
export function DiscardChangesDialog({ open, onKeepEditing, onDiscard }: Props) {
  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) onKeepEditing();
      }}
      title="Discard Unsaved Changes?"
      description="You have unsaved changes. Discarding will lose them."
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onKeepEditing} autoFocus>
            Keep Editing
          </Button>
          <Button variant="destructive" onClick={onDiscard}>
            Discard Changes
          </Button>
        </>
      }
    />
  );
}
